import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'

Vue.config.productionTip = false

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import * as routerHelper from '@/utils/routerHelper'
// 初始化 router 实例
routerHelper.initRouter(router)

// 挂载到 Vue 原型
Vue.prototype.$goTo = routerHelper.$goTo
Vue.prototype.$goBack = routerHelper.$goBack
Vue.prototype.$replace = routerHelper.$replace
Vue.prototype.$goToName = routerHelper.$goToName

import VueMarqueeSlider from 'vue-marquee-slider'
Vue.use(VueMarqueeSlider)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
